export default "__VITE_ASSET__7bb09b12__"